var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.20007C15 3.78003 14.9997 3.56986 14.918 3.40942C14.8461 3.2683 14.7318 3.15365 14.5906 3.08175C14.4302 3 14.2197 3 13.7997 3H4.19971C3.77967 3 3.56986 3 3.40942 3.08175C3.2683 3.15365 3.15365 3.2683 3.08175 3.40942C3 3.56986 3 3.78003 3 4.20007V4.75302C3 4.93646 3 5.02825 3.02072 5.11457C3.0391 5.19109 3.06947 5.26419 3.1106 5.3313C3.15696 5.40696 3.22193 5.47193 3.35156 5.60156L7.14862 9.39862C7.27832 9.52832 7.34283 9.59283 7.38921 9.66851C7.43033 9.73562 7.46112 9.80897 7.47949 9.8855C7.5 9.97093 7.5 10.0616 7.5 10.2414V13.8083C7.5 14.4512 7.5 14.7728 7.63541 14.9664C7.75365 15.1355 7.93605 15.2482 8.14014 15.2784C8.37385 15.3129 8.66153 15.1693 9.23657 14.8818L9.83657 14.5818C10.0774 14.4614 10.1975 14.401 10.2854 14.3112C10.3632 14.2317 10.4227 14.1364 10.459 14.0313C10.5 13.9124 10.5 13.7775 10.5 13.5083V10.2469C10.5 10.0635 10.5 9.97181 10.5207 9.8855C10.5391 9.80897 10.5695 9.73562 10.6106 9.66851C10.6567 9.59333 10.721 9.529 10.849 9.40101L10.8516 9.39862L14.6486 5.60156C14.7783 5.47185 14.8428 5.40699 14.8892 5.3313C14.9303 5.26419 14.9611 5.19109 14.9795 5.11457C15 5.02913 15 4.93833 15 4.7586V4.20007Z",
    stroke: "#636980",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownFilter);
export default __webpack_public_path__ + "static/media/dropdown_Filter.594fbfd5206a76866aaf0c8a7e19d7f4.svg";
export { ForwardRef as ReactComponent };